var B = Object.defineProperty;
var g = (u, e, t) => e in u ? B(u, e, { enumerable: !0, configurable: !0, writable: !0, value: t }) : u[e] = t;
var h = (u, e, t) => g(u, typeof e != "symbol" ? e + "" : e, t);
class w {
  constructor(e) {
    h(this, "strToUniqueId", /* @__PURE__ */ new Map());
    h(this, "uniqueIdToStr", /* @__PURE__ */ new Map());
    h(this, "currentUniqueId", 0);
    if (e)
      for (const [t, s] of e)
        this.strToUniqueId.set(t, s), this.uniqueIdToStr.set(s, t), this.currentUniqueId = Math.max(this.currentUniqueId, s + 1);
  }
  id(e) {
    const t = this.strToUniqueId.get(e);
    if (t !== void 0)
      return t;
    const s = this.currentUniqueId++;
    return this.strToUniqueId.set(e, s), this.uniqueIdToStr.set(s, e), s;
  }
  str(e) {
    const t = this.uniqueIdToStr.get(e);
    if (!t)
      throw new Error("pub: invalid id " + e);
    return t;
  }
  has(e) {
    return this.strToUniqueId.has(e);
  }
  serialize() {
    return Array.from(this.strToUniqueId.entries());
  }
  *[Symbol.iterator]() {
    yield* this.uniqueIdToStr.entries();
  }
  remove(e) {
    const t = this.uniqueIdToStr.get(e);
    t !== void 0 && (this.uniqueIdToStr.delete(e), this.strToUniqueId.delete(t));
  }
}
const y = /^[0-9a-fA-F]{64}$/;
class m {
  constructor(e, t) {
    h(this, "root");
    h(this, "followDistanceByUser", /* @__PURE__ */ new Map());
    h(this, "usersByFollowDistance", /* @__PURE__ */ new Map());
    h(this, "followedByUser", /* @__PURE__ */ new Map());
    h(this, "followersByUser", /* @__PURE__ */ new Map());
    h(this, "followListCreatedAt", /* @__PURE__ */ new Map());
    h(this, "mutedByUser", /* @__PURE__ */ new Map());
    h(this, "userMutedBy", /* @__PURE__ */ new Map());
    h(this, "muteListCreatedAt", /* @__PURE__ */ new Map());
    h(this, "ids", new w());
    this.ids = new w(t && t.uniqueIds), this.root = this.id(e), this.followDistanceByUser.set(this.root, 0), this.usersByFollowDistance.set(0, /* @__PURE__ */ new Set([this.root])), t && this.deserialize(t);
  }
  id(e) {
    return this.ids.id(e);
  }
  str(e) {
    return this.ids.str(e);
  }
  getRoot() {
    return this.str(this.root);
  }
  setRoot(e) {
    const t = this.id(e);
    t !== this.root && (this.root = t, this.recalculateFollowDistances());
  }
  recalculateFollowDistances() {
    this.followDistanceByUser.clear(), this.usersByFollowDistance.clear(), this.followDistanceByUser.set(this.root, 0), this.usersByFollowDistance.set(0, /* @__PURE__ */ new Set([this.root]));
    const e = [this.root];
    for (; e.length > 0; ) {
      const t = e.shift(), s = this.followDistanceByUser.get(t), o = this.followedByUser.get(t) || /* @__PURE__ */ new Set();
      for (const i of o)
        if (!this.followDistanceByUser.has(i)) {
          const r = s + 1;
          this.followDistanceByUser.set(i, r), this.usersByFollowDistance.has(r) || this.usersByFollowDistance.set(r, /* @__PURE__ */ new Set()), this.usersByFollowDistance.get(r).add(i), e.push(i);
        }
    }
  }
  handleEvent(e) {
    const t = (Array.isArray(e) ? e : [e]).filter((s) => [3, 1e4].includes(s.kind));
    for (const s of t) {
      const o = s.created_at;
      if (o > Math.floor(Date.now() / 1e3) + 10 * 60) {
        console.debug("event.created_at more than 10 minutes in the future", s);
        continue;
      }
      const i = this.id(s.pubkey);
      s.kind === 3 ? this.handleFollowList(s, i, o) : s.kind === 1e4 && this.handleMuteList(s, i, o);
    }
  }
  handleFollowList(e, t, s) {
    const o = this.followListCreatedAt.get(t);
    if (o && s <= o)
      return;
    this.followListCreatedAt.set(t, s);
    const i = /* @__PURE__ */ new Set();
    for (const n of e.tags)
      if (n[0] === "p") {
        if (!y.test(n[1]))
          continue;
        const d = this.id(n[1]);
        d !== t && i.add(d);
      }
    const r = this.followedByUser.get(t) || /* @__PURE__ */ new Set();
    for (const n of r)
      i.has(n) || this.privateRemoveFollower(n, t);
    for (const n of i)
      this.privateAddFollower(n, t);
  }
  handleMuteList(e, t, s) {
    var n, d, c, f;
    const o = this.muteListCreatedAt.get(t);
    if (o && s <= o)
      return;
    this.muteListCreatedAt.set(t, s);
    const i = /* @__PURE__ */ new Set();
    for (const l of e.tags)
      if (l[0] === "p") {
        if (!y.test(l[1]))
          continue;
        const a = this.id(l[1]);
        a !== t && i.add(a);
      }
    const r = this.mutedByUser.get(t) || /* @__PURE__ */ new Set();
    for (const l of r)
      i.has(l) || ((n = this.mutedByUser.get(t)) == null || n.delete(l), (d = this.userMutedBy.get(l)) == null || d.delete(t));
    for (const l of i)
      this.mutedByUser.has(t) || this.mutedByUser.set(t, /* @__PURE__ */ new Set()), (c = this.mutedByUser.get(t)) == null || c.add(l), this.userMutedBy.has(l) || this.userMutedBy.set(l, /* @__PURE__ */ new Set()), (f = this.userMutedBy.get(l)) == null || f.add(t);
  }
  isFollowing(e, t) {
    var i;
    const s = this.id(t), o = this.id(e);
    return !!((i = this.followedByUser.get(o)) != null && i.has(s));
  }
  getFollowDistance(e) {
    const t = this.followDistanceByUser.get(this.id(e));
    return t === void 0 ? 1e3 : t;
  }
  addUserByFollowDistance(e, t) {
    var s, o;
    this.usersByFollowDistance.has(e) || this.usersByFollowDistance.set(e, /* @__PURE__ */ new Set()), (s = this.usersByFollowDistance.get(e)) == null || s.add(t);
    for (const i of this.usersByFollowDistance.keys())
      i > e && ((o = this.usersByFollowDistance.get(i)) == null || o.delete(t));
  }
  privateAddFollower(e, t) {
    var s, o;
    if (typeof e != "number" || typeof t != "number")
      throw new Error("Invalid user id");
    if (this.followersByUser.has(e) || this.followersByUser.set(e, /* @__PURE__ */ new Set()), (s = this.followersByUser.get(e)) == null || s.add(t), this.followedByUser.has(t) || this.followedByUser.set(t, /* @__PURE__ */ new Set()), e !== this.root) {
      let i;
      if (t === this.root)
        i = 1, this.addUserByFollowDistance(i, e), this.followDistanceByUser.set(e, i);
      else {
        const r = this.followDistanceByUser.get(e), n = this.followDistanceByUser.get(t);
        i = n && n + 1, (r === void 0 || i && i < r) && (this.followDistanceByUser.set(e, i), this.addUserByFollowDistance(i, e));
      }
    }
    (o = this.followedByUser.get(t)) == null || o.add(e);
  }
  addFollower(e, t) {
    this.privateAddFollower(this.id(t), this.id(e));
  }
  removeFollower(e, t) {
    this.privateRemoveFollower(this.id(t), this.id(e));
  }
  privateRemoveFollower(e, t) {
    var o, i;
    if ((o = this.followersByUser.get(e)) == null || o.delete(t), (i = this.followedByUser.get(t)) == null || i.delete(e), e === this.root)
      return;
    let s = 1 / 0;
    for (const r of this.followersByUser.get(e) || []) {
      const n = this.followDistanceByUser.get(r);
      n !== void 0 && n + 1 < s && (s = n + 1);
    }
    s === 1 / 0 ? this.followDistanceByUser.delete(e) : this.followDistanceByUser.set(e, s);
  }
  followerCount(e) {
    var s;
    const t = this.id(e);
    return ((s = this.followersByUser.get(t)) == null ? void 0 : s.size) ?? 0;
  }
  followedByFriendsCount(e) {
    var o;
    let t = 0;
    const s = this.id(e);
    for (const i of this.followersByUser.get(s) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(i) && t++;
    return t;
  }
  mutedByFriendsCount(e) {
    var o;
    let t = 0;
    const s = this.id(e);
    for (const i of this.userMutedBy.get(s) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(i) && t++;
    return t;
  }
  size() {
    let e = 0, t = 0;
    const s = {};
    for (const o of this.followedByUser.values())
      e += o.size;
    for (const o of this.mutedByUser.values())
      t += o.size;
    for (const [o, i] of this.usersByFollowDistance.entries())
      s[o] = i.size;
    return {
      users: this.followDistanceByUser.size,
      follows: e,
      mutes: t,
      sizeByDistance: s
    };
  }
  followedByFriends(e) {
    var o;
    const t = this.id(e), s = /* @__PURE__ */ new Set();
    for (const i of this.followersByUser.get(t) ?? [])
      (o = this.followedByUser.get(this.root)) != null && o.has(i) && s.add(this.str(i));
    return s;
  }
  getFollowedByUser(e, t = !1) {
    const s = this.id(e), o = /* @__PURE__ */ new Set();
    for (const i of this.followedByUser.get(s) || [])
      o.add(this.str(i));
    return t && o.add(e), o;
  }
  getFollowersByUser(e) {
    const t = this.id(e), s = /* @__PURE__ */ new Set();
    for (const o of this.followersByUser.get(t) || [])
      s.add(this.str(o));
    return s;
  }
  serialize(e) {
    const t = [], s = [];
    for (const [o, i] of this.followedByUser) {
      const r = this.followListCreatedAt.get(o);
      if (r && (t.push([o, [...i.values()], r]), e && t.length >= e))
        return { followLists: t, uniqueIds: this.ids.serialize() };
    }
    for (const [o, i] of this.mutedByUser) {
      const r = this.muteListCreatedAt.get(o);
      r && s.push([o, [...i.values()], r]);
    }
    return { followLists: t, uniqueIds: this.ids.serialize(), muteLists: s };
  }
  deserialize(e) {
    var i, r;
    const { followLists: t, muteLists: s } = e, o = (i = t[0]) == null ? void 0 : i[0];
    for (const [n, d, c] of t) {
      for (const f of d)
        this.privateAddFollower(f, n);
      this.followListCreatedAt.set(n, c ?? 0);
    }
    if (s)
      for (const [n, d, c] of s) {
        this.mutedByUser.set(n, new Set(d));
        for (const f of d)
          this.userMutedBy.has(f) || this.userMutedBy.set(f, /* @__PURE__ */ new Set()), (r = this.userMutedBy.get(f)) == null || r.add(n);
        this.muteListCreatedAt.set(n, c ?? 0);
      }
    o !== this.root && this.recalculateFollowDistances();
  }
  getUsersByFollowDistance(e) {
    const t = this.usersByFollowDistance.get(e) || /* @__PURE__ */ new Set(), s = /* @__PURE__ */ new Set();
    for (const o of t)
      s.add(this.str(o));
    return s;
  }
  getFollowListCreatedAt(e) {
    return this.followListCreatedAt.get(this.id(e));
  }
  merge(e) {
    console.log("size before merge", this.size()), console.time("merge graph");
    for (const t of e)
      this.mergeUserLists(
        t,
        this.followListCreatedAt,
        e.followListCreatedAt,
        this.followedByUser,
        e.followedByUser
      ), this.mergeUserLists(
        t,
        this.muteListCreatedAt,
        e.muteListCreatedAt,
        this.mutedByUser,
        e.mutedByUser
      );
    this.recalculateFollowDistances(), console.timeEnd("merge graph"), console.log("size after merge", this.size());
  }
  mergeUserLists(e, t, s, o, i) {
    const r = this.id(e), n = t.get(r), d = s.get(r);
    if (!n || d && n < d) {
      const c = i.get(r) || /* @__PURE__ */ new Set(), f = o.get(r) || /* @__PURE__ */ new Set();
      for (const l of c)
        f.has(l) || (o.has(r) || o.set(r, /* @__PURE__ */ new Set()), o.get(r).add(l));
      for (const l of f)
        c.has(l) || o.get(r).delete(l);
      t.set(r, d ?? 0);
    }
  }
  *userIterator(e) {
    const t = Array.from(this.usersByFollowDistance.keys()).sort((s, o) => s - o);
    for (const s of t) {
      if (e !== void 0 && s > e)
        break;
      const o = this.usersByFollowDistance.get(s) || /* @__PURE__ */ new Set();
      for (const i of o)
        yield this.str(i);
    }
  }
  [Symbol.iterator]() {
    return this.userIterator();
  }
  getMutedByUser(e) {
    const t = this.id(e), s = /* @__PURE__ */ new Set();
    for (const o of this.mutedByUser.get(t) || [])
      s.add(this.str(o));
    return s;
  }
  getUserMutedBy(e) {
    const t = this.id(e), s = /* @__PURE__ */ new Set();
    for (const o of this.userMutedBy.get(t) || [])
      s.add(this.str(o));
    return s;
  }
  // follower and muter counts by distance
  stats(e) {
    const t = {}, s = this.id(e);
    for (const o of this.followersByUser.get(s) || []) {
      const i = this.followDistanceByUser.get(o);
      i !== void 0 && (t[i] || (t[i] = { followers: 0, muters: 0 }), t[i].followers++);
    }
    for (const o of this.userMutedBy.get(s) || []) {
      const i = this.followDistanceByUser.get(o);
      i !== void 0 && (t[i] || (t[i] = { followers: 0, muters: 0 }), t[i].muters++);
    }
    return t;
  }
  removeMutedNotFollowedUsers() {
    const e = /* @__PURE__ */ new Set();
    for (const [t, s] of this.userMutedBy.entries())
      (this.followersByUser.get(t) || /* @__PURE__ */ new Set()).size === 0 && s.size > 0 && e.add(t);
    for (const t of e)
      this.removeUserById(t);
    return e.size;
  }
  removeUserById(e) {
    this.ids.remove(e), this.followDistanceByUser.delete(e), this.followedByUser.delete(e), this.followersByUser.delete(e), this.followListCreatedAt.delete(e), this.mutedByUser.delete(e), this.userMutedBy.delete(e), this.muteListCreatedAt.delete(e), this.usersByFollowDistance.forEach((t) => t.delete(e)), this.followedByUser.forEach((t) => t.delete(e)), this.followersByUser.forEach((t) => t.delete(e)), this.mutedByUser.forEach((t) => t.delete(e)), this.userMutedBy.forEach((t) => t.delete(e));
  }
}
export {
  m as SocialGraph,
  w as UniqueIds
};
